import { environment } from 'src/environments/environment'
import axios from 'axios'
import { token } from 'src/services/auth.service'

export async function newHttpHeaders() {
  const headers = {
    Authorization: `Bearer` + (await token())
  }
  return headers
}

export const coreAPI = axios.create({
  baseURL: environment.rootUrl
})
coreAPI.interceptors.request.use((config) => {
  if (config.headers === undefined) config.headers = {}
  if (config.headers['Authorization'] === undefined) {
    config.headers['Authorization'] = `Bearer ${token()}`
  }
  if (config.headers['Content-Type'] === undefined) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})
coreAPI.interceptors.response.use(
  (res) => res,
  (error) => console.error(error)
)

export const gatewayAPI = axios.create({
  baseURL: environment.gatewayUrl
})
gatewayAPI.interceptors.request.use((config) => {
  if (config.headers === undefined) config.headers = {}
  if (config.headers['Authorization'] === undefined) {
    config.headers['Authorization'] = `Bearer ${token()}`
  }
  if (config.headers['Content-Type'] === undefined) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})
gatewayAPI.interceptors.response.use(
  (res) => res,
  (error) => console.error(error)
)

export const keycloakServiceAPI = axios.create({
  baseURL: environment.keycloakServiceUrl
})
keycloakServiceAPI.interceptors.request.use((config) => {
  if (config.headers === undefined) config.headers = {}
  if (config.headers['Authorization'] === undefined) {
    config.headers['Authorization'] = `Bearer ${token()}`
  }
  if (config.headers['Content-Type'] === undefined) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})
keycloakServiceAPI.interceptors.response.use(
  (res) => res,
  (error) => console.error(error)
)
export const groupServiceApi = axios.create({
  baseURL: environment.keycloakServiceUrl
})
groupServiceApi.interceptors.request.use((config) => {
  if (config.headers === undefined) config.headers = {}
  if (config.headers['Authorization'] === undefined) {
    config.headers['Authorization'] = `Bearer ${token()}`
  }
  if (config.headers['Content-Type'] === undefined) {
    config.headers['Content-Type'] = 'text/plain'
  }
  return config
})
groupServiceApi.interceptors.response.use(
  (res) => res,
  (error) => console.error(error)
)
export const poiApi = axios.create({
  baseURL: `${environment.gatewayUrl}/poi`
})
poiApi.interceptors.request.use((config) => {
  if (config.headers === undefined) config.headers = {}
  if (config.headers['Authorization'] === undefined) {
    config.headers['Authorization'] = `Bearer ${token()}`
  }
  if (config.headers['Content-Type'] === undefined) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})
poiApi.interceptors.response.use(
  (res) => res,
  (error) => console.error(error)
)
export const zoneApi = axios.create({
  baseURL: `${environment.gatewayUrl}/zone`
})
zoneApi.interceptors.request.use((config) => {
  if (config.headers === undefined) config.headers = {}
  if (config.headers['Authorization'] === undefined) {
    config.headers['Authorization'] = `Bearer ${token()}`
  }
  if (config.headers['Content-Type'] === undefined) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})
